module.exports = __webpack_public_path__ + "img/new_unactive_08.58e745e8.jpg";